module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/filter-primary-40cbb9064a3c81d3589cb369544012b6.svg&quot;;"